import { accessControlService } from '@/services/access-control.service'
import { useAuthStore } from '@/stores/auth.store'
import { useQuery } from '@tanstack/react-query'

export const accessControlKeys = {
  all: ['access-control'] as const,
  context: (userId: string | number) => [...accessControlKeys.all, 'context', userId] as const,
  userRoles: (userId: number, includeExpired = false) =>
    [...accessControlKeys.all, 'users', userId, 'roles', { includeExpired }] as const,
  audit: (targetUserId?: number) =>
    [...accessControlKeys.all, 'audit', targetUserId ?? 'all'] as const,
}

export function useAccessControl(enabled = true) {
  const user = useAuthStore((state) => state.user)
  const token = useAuthStore((state) => state.token)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return useQuery({
    queryKey: accessControlKeys.context(user?.id ?? 'anonymous'),
    queryFn: () => accessControlService.getContext(),
    enabled: enabled && isAuthenticated && !!token && !!user,
    staleTime: 0,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: (failureCount, error) => {
      const status =
        typeof error === 'object' && error !== null && 'statusCode' in error
          ? error.statusCode
          : undefined
      return status !== 401 && status !== 403 && failureCount < 2
    },
  })
}
